import {createErrorAction} from './utils';

const TYPES = {
    GET_PLAYRATE: 'GET_PLAYRATE',
    GET_PLAYRATE_COMPLETE: 'GET_PLAYRATE_COMPLETE',
    GET_PLAYRATE_FAILED: 'GET_PLAYRATE_FAILED'
};

export default {
    TYPES,

    getPlayrate: payload => ({
        type: TYPES.GET_PLAYRATE,
        payload
    }),

    getPlayrateSuccess: payload => ({
        type: TYPES.GET_PLAYRATE_COMPLETE,
        payload
    }),

    getPlayrateFailed: createErrorAction(TYPES.GET_PLAYRATE_FAILED)
};
